import { Component } from '@angular/core';
import { BaseListComponent } from '@common/classes/base-list';
import { ColumnSettings } from '@common/interfaces/column-settings.interface';
import { CommonService } from '@common/services/common.service';
import { SortDescriptor } from '@progress/kendo-data-query';
import { MessageLogDialogComponent } from './message-log-dialog/message-log-dialog.component';

@Component({
    selector: 'app-message-log',
    providers: [CommonService],
    templateUrl: './message-log.component.html',
    styleUrl: './message-log.component.scss'
})
export class MessageLogComponent extends BaseListComponent {
    override columns: ColumnSettings[];
    override queryName: string = 'MessageLogs';

    constructor(common: CommonService) {
        super(common);
    }

    gridSort: SortDescriptor[] = [
        {
            field: 'id',
            dir: 'desc'
        }
    ];

    openMessageDialog(message: string) {
        this.dialogService.open({
            template: {
                content: MessageLogDialogComponent,
                data: { message }
            },
            dialogSettings: {
                width: '70%',
                height: '80%'
            }
        });
    }
}
